import SlideFrame from "./_SlideFrame";

export default function SlideProblem() {
  return (
    <SlideFrame tag="01 · The Case">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <p className="overline mb-6">Reframe</p>
          <h2 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95] font-medium">
            Servicing isn&rsquo;t a headache — it&rsquo;s a <span className="italic text-primary">missed opportunity</span>.
          </h2>
          <p className="mt-10 text-lg text-foreground/75 max-w-2xl leading-relaxed">
            Most lenders treat the post-funding motion as a problem to push down the chain —
            outsourcing to slow, old-line servicers the moment the loan books. That's where the
            relationship, the data, and the upside get left on the table.
          </p>
          <p className="mt-5 text-lg text-foreground/75 max-w-2xl leading-relaxed">
            Servicing done well is how you <em className="italic">keep customers in the fold</em>, harvest
            first-party performance data, and move fast enough to bid on — or sell into —
            portfolios when the market turns.
          </p>
        </div>
        <div className="lg:col-span-5 border-t lg:border-t-0 lg:border-l border-foreground/20 lg:pl-10 pt-8 lg:pt-0">
          <p className="overline mb-6">What modern servicing unlocks</p>
          <ul className="space-y-5 font-display text-2xl">
            <li className="flex gap-4"><span className="font-mono-data text-sm text-muted-foreground pt-2">01</span>Expertise &amp; innovation, not a ticket queue</li>
            <li className="flex gap-4"><span className="font-mono-data text-sm text-muted-foreground pt-2">02</span>First-party data for better underwriting</li>
            <li className="flex gap-4"><span className="font-mono-data text-sm text-muted-foreground pt-2">03</span>Customers returned to the fold, not churned out</li>
            <li className="flex gap-4"><span className="font-mono-data text-sm text-muted-foreground pt-2">04</span>Fast execution for portfolio sales &amp; bids</li>
          </ul>
          <p className="mt-8 text-sm text-muted-foreground leading-relaxed">
            The lenders who win the next cycle will be the ones who stopped treating servicing
            as someone else&rsquo;s problem.
          </p>
        </div>
      </div>
    </SlideFrame>
  );
}
